import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from '@/context/ThemeContext'
import ClientLayout from '@/components/ClientLayout'
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
import HomePage from '@/src/pages/HomePage'
import BassiliChatAIPage from '@/src/pages/BassiliChatAIPage'
import BassiliTradePage from '@/src/pages/BassiliTradePage'

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <ClientLayout>
          <Navbar />
          <main className="min-h-screen">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/bassilichatai" element={<BassiliChatAIPage />} />
              <Route path="/bassilitrade" element={<BassiliTradePage />} />
            </Routes>
          </main>
          <Footer />
        </ClientLayout>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
